import { InjectionToken } from '@angular/core';

export enum ArrowType {
    None,
    Left,
    Right,
}

export enum OptionType {
    Regular,
    Special,
}

export interface OptionBadge {
    text: string;
    cssClass: string;
}

export interface DropdownOption<T = any> {
    id: string | number;
    name?: string;
    disabled?: boolean;
    payload?: T;
    type?: OptionType;
    arrowType?: ArrowType;
    automation?: any;
    badge?: OptionBadge;
}

export const DROPDOWN_CUSTOM_CLASS = new InjectionToken<string>('DROPDOWN_CUSTOM_CLASS');
